export const {REACT_APP_FITVIEW_CLIENT_URL,REACT_APP_SWAN_API_SERVER_URL,REACT_APP_CHILD_URL,REACT_APP_ACCESS_KEY,REACT_APP_WEBSOCKET_URL}  = process.env;
export const PARAMS_NAME={
    SCAN_ID:"scan_id",
    EMAIL:"email",
    TOKEN:"token",
    FIT:"fit",
    CART:"cart"
    
}
export const STORAGE_KEY={
    SCAN_ID:"scanID",
    FACE_SCAN_ID:"faceScanID",
    EMAIL:"email",
    JWTToken:"JWTToken"
}

export const MESSAGE_KEY={
    REDIRECT:"REDIRECT",
    REQUEST:"REQUEST",
    DETAILS:"DETAILS",
    CLOSE:"CLOSE",
    INFO:"INFO"
}
export const CUSTOM_STORE={
    HOUSE_OF_ALDENO:'aldeno-laguna-clothing.myshopify.com',
    SWAN_CUSTOM_STORE_STAGING:'swan-custom-staging.myshopify.com'
}

export const SCAN_TYPE={
    CLOTHING_SCAN_WITH_TRY_ON:"CLOTHING_SCAN_WITH_TRY_ON",
    CLOTHIN_SCAN_ONLY:"CLOTHIN_SCAN_ONLY",
    CLOTHING_TRY_ON_ONLY:"CLOTHING_TRY_ON_ONLY"
}
export const SIZE_SELECT_DATA=[{id:1,name:"Ideal",value:"ideal"},{id:2,name:"Fitted",value:"fitted"},{id:3,name:"Relaxed",value:"relaxed"}]

export const BOTTOM_VIEW={
    MEASUREMENT:"MEASUREMENT",
    PRODUCT:"PRODUCT",
    NONE:"NONE"
}

export const API_ENDPOINTS={
    tryon: {
		tryonProductMetadata: "/tryon/product-metadata",
		tryonProductStructure: "/tryon/product-structure",
		tryonProductCheckWebsocket: "/tryon",
		tryonProductShareFeedback: "/tryon/feedback"
	}
}
export const TOKEN_DATA_TYPE = {
	ACCESS :"ACCESS",
	INTERNAL: "INTERNAL",
}
export const FALLBACK = "FALLBACK";

export const SCAN_STATUS ={
    FULLFILLED:"FULLFILLED",
    PENDING:"PENDING",
    FAILED:"FAILED"
}
export const ADDIDAS_EMAILS=[{id:1,email: "eoin@getswan.co",gender:"male"},{id:2,email: "eoin@syze.ai",gender:"female"},{id:3,email: "paras+adidasm@getswan.co",gender:"male"},{id:4,email: "paras+adidasf@getswan.co",gender:"female"},{id:5,email: "rio@yopmail.com",gender:"male"}];
export const ADIDAS_SHOPDOMAIN ="swan-adidas-demo.myshopify.com";
export const HARDCODED_SCAN_ID_FEMALE="526bc88d-fd10-464e-921d-799f6e2d0749";
export const HARDCODED_SCAN_ID_MALE="595c1935-86cf-408a-892f-83c634f5a8c9";
